/**
 * Which routes belong to one of the three dashboard surfaces (investor/staff/admin) — used to
 * scope dark-mode application there and force every other page (auth, onboarding/portfolio-audit
 * flows) to always render light, regardless of the dashboard theme preference. `/profile` is the
 * investor shell's profile page, a sibling of `/dashboard` under the same `(investor)/(shell)`
 * route group (see `routes.investor.profile` in `src/config/routes.ts`); `/staff` and `/admin`
 * cover their entire route trees per `routes.staff.*`/`routes.admin.*`.
 */
export const DASHBOARD_ROUTE_PREFIXES = ['/dashboard', '/profile', '/staff', '/admin'] as const

export function isDashboardRoute(pathname: string): boolean {
  return DASHBOARD_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}
